// The defination of RuntimeLifeTime must be syncd up with defination in SharedRuntime.cs.
enum RuntimeLifeTime {
  Short = 0,
  Long,
}
namespace OSF {
  export namespace Manifest {
    export class RuntimeOverride {
      Resid: string;
      Type: string;
    }
    export let Runtime = function OSF_Manifest_Runtime() {
      this.Resid = null;
      this.LifeTime = RuntimeLifeTime.Short;
      this.Overrides = [] as RuntimeOverride[];
    };
    export class HostApp {
      _appName: any;
      _minVersion: any;
      constructor(appName) {
        this._appName = appName;
        this._minVersion = null;
      }
      getAppName() {
        return this._appName;
      }
      getMinVersion() {
        return this._minVersion;
      }
      _setMinVersion(minVersion) {
        this._minVersion = minVersion;
      }
    }
    export class ExtensionSettings {
      _defaultHeight: any;
      _defaultWidth: any;
      _sourceLocations: any;
      constructor() {
        this._sourceLocations = {};
        this._defaultHeight = null;
        this._defaultWidth = null;
      }
      getDefaultHeight() {
        return this._defaultHeight;
      }
      getDefaultWidth() {
        return this._defaultWidth;
      }
      getSourceLocations() {
        return this._sourceLocations;
      }
      _addSourceLocation(locale, value) {
        this._sourceLocations[locale.toLocaleLowerCase()] = value;
      }
      _setDefaultWidth(defaultWidth) {
        this._defaultWidth = defaultWidth;
      }
      _setDefaultHeight(defaultHeight) {
        this._defaultHeight = defaultHeight;
      }
    }
    export class WebAppInfoAuthorization {
      _resource: any;
      _scopes: any;
      constructor() {
        this._resource = null;
        this._scopes = null;
      }
      getResource() {
        return this._resource;
      }
      getScopes() {
        return this._scopes;
      }
    }
    export class EquivalentAddins {
      _equivalentAddins: any;
      constructor() {
        this._equivalentAddins = [];
      }
      isXLLCompatible() {
        for (var i = 0; i < this._equivalentAddins.length; i++) {
          if (this._equivalentAddins[i].isXLLCompatible()) {
            return true;
          }
        }
        return false;
      }
      add(equivalentAddin) {
        this._equivalentAddins.push(equivalentAddin);
      }
      getEquivalentAddins() {
        return this._equivalentAddins;
      }
    }
    export class EquivalentAddin {
      _progId: any;
      _displayName: any;
      _fileName: any;
      _type: any;
      constructor() {
        this._progId = null;
        this._displayName = null;
        this._fileName = null;
        this._type = null;
      }
      getProgId() {
        return this._progId;
      }
      getDisplayName() {
        return this._displayName;
      }
      getFileName() {
        return this._fileName;
      }
      getType() {
        return this._type;
      }
      isXLLCompatible() {
        return this._type == "XLL";
      }
      isComAddin() {
        return this._type == "COM";
      }
    }
    export class Runtimes {
      _runtimes: any;
      constructor() {
        this._runtimes = [];
      }
      getSharedRuntime(resid) {
        if (resid == null || this._runtimes == null) {
          return null;
        }
        for (var i = 0; i < this._runtimes.length; i++) {
          if (this._runtimes[i] != null && this._runtimes[i].Resid === resid) {
            return this._runtimes[i];
          }
        }
        return null;
      }
      add(runtime) {
        if (runtime == null || this._runtimes == null) {
          return;
        }
        // Check if this._runtimes already contains item with same resid.
        if (this.getSharedRuntime(runtime.Resid) != null) {
          throw OsfMsAjaxFactory.msAjaxError.argument(
            "Manifest parser failure: cannot have same Resid for different runtime.",
          );
        }
        this._runtimes.push(runtime);
      }
      getRuntimes() {
        return this._runtimes;
      }
    }
    export enum ResourceType {
      Image = 1,
      Url = 2,
      ShortString = 3,
      LongString = 4,
    }
    export class Manifest {
      _UILocale: any;
      // _displayNames gets overridden with the title for the taskpane if title exists.
      // we keep original displayNames as _addinDisplayNames for the addin. see `AddinCommandsManifestManagerImpl`
      _addinDisplayNames: any;
      _allowSnapshot: any;
      _alternateId: any;
      _appDomains: any;
      _capabilities: any;
      _defaultLocale: any;
      _descriptions: any;
      _displayNames: any;
      _equivalentAddins: any;
      _extendedOverrides: any;
      _extendedOverridesTokens: any;
      _extensionSettings: any;
      _highResolutionIconUrls: any;
      _hosts: any;
      _hostsXml: any;
      _iconUrls: any;
      _supportUrls: any;
      _id: any;
      _idIssuer: any;
      _inMemoryEToken: any;
      _manifestSchemaVersion: any;
      _manifestSourceLocationOverrides: any;
      _permissions: any;
      _providerName: any;
      _requirements: any;
      _requirementsXml: any;
      _resources: any;
      _ribbonExtensionControls: any;
      _signature: any;
      _target: any;
      _version: any;
      _versionOverrides: any;
      _webApplicationAuthorizations: any;
      _webApplicationId: any;
      _webApplicationMsaId: any;
      _webApplicationResource: any;
      _webApplicationScopes: any;
      _xmlProcessor: any;
      _localesSeen: any;
      _payloadType: OSF.PayloadType;
      _solutionRef?: OfficeExt.OsfSolutionReference;

      /// <summary>
      /// representing the Osf Control manifest
      /// </summary>
      /// <param name="para">manifest XML (type: string)</param>
      /// <param name="uiLocale">UI locale (type: string)</param>
      constructor(para, uiLocale, payloadType?, solutionReference?) {
        this._UILocale = uiLocale || "en-us";
        if (solutionReference != null) {
          this._solutionRef = solutionReference;
        }
        if (payloadType && payloadType === PayloadType.MosAcquisition) {
          this._payloadType = PayloadType.MosAcquisition;
        } else {
          this._payloadType = PayloadType.OfficeAddin;
          if (typeof para !== "string") {
            para(this);
            return;
          }
          this._displayNames = {};
          this._descriptions = {};
          this._iconUrls = {};
          this._supportUrls = {};
          this._extensionSettings = {};
          this._highResolutionIconUrls = {};
          this._versionOverrides = {};
          this._ribbonExtensionControls = {};
          this._localesSeen = {};
          var versionSpecificDelegate;
          // Find manifest version
          this._xmlProcessor = new OSF.XmlProcessor(para, OSF.ManifestNamespaces["1.1"]);
          if (this._xmlProcessor.selectSingleNode("o:OfficeApp")) {
            versionSpecificDelegate = OSF_Manifest_Manifest_Manifest1_1;
            this._manifestSchemaVersion = OSF.ManifestSchemaVersion["1.1"];
          } else {
            this._xmlProcessor = new OSF.XmlProcessor(para, OSF.ManifestNamespaces["1.0"]);
            versionSpecificDelegate = OSF_Manifest_Manifest_Manifest1_0;
            this._manifestSchemaVersion = OSF.ManifestSchemaVersion["1.0"];
          }
          var node = this._xmlProcessor.getDocumentElement();
          this._target = OSF.OUtil.parseEnum(this.getNodeXsiType(node), OSF.OfficeAppType);
          var officeAppNode = this._xmlProcessor.selectSingleNode("o:OfficeApp");
          node = this._xmlProcessor.selectSingleNode("o:Id", officeAppNode);
          this._id = this._xmlProcessor.getNodeValue(node);
          if (this.isForOfficeAppManifest()) {
            this._id = this._id.replace(/\{|\}/gi, "");
          }
          var guidRegex = new RegExp("^[a-f0-9]{8}(-[a-f0-9]{4}){3}-[a-f0-9]{12}$", "i");
          if (!guidRegex.test(this._id)) {
            throw OsfMsAjaxFactory.msAjaxError.argument("Manifest");
          }
          node = this._xmlProcessor.selectSingleNode("o:Version", officeAppNode);
          // Do not allow any new failures here!
          try {
            this._version = this.complementVersion(this._xmlProcessor.getNodeValue(node));
          } catch {
            this._version = this._xmlProcessor.getNodeValue(node);
          }
          node = this._xmlProcessor.selectSingleNode("o:ProviderName", officeAppNode);
          this._providerName = this._xmlProcessor.getNodeValue(node);
          node = this._xmlProcessor.selectSingleNode("o:IdIssuer", officeAppNode);
          this._idIssuer = this._parseIdIssuer(node);
          node = this._xmlProcessor.selectSingleNode("o:AlternateId", officeAppNode);
          if (node) {
            this._alternateId = this._xmlProcessor.getNodeValue(node);
          }
          node = this._xmlProcessor.selectSingleNode("o:DefaultLocale", officeAppNode);
          this._defaultLocale = this._xmlProcessor.getNodeValue(node);
          node = this._xmlProcessor.selectSingleNode("o:DisplayName", officeAppNode);
          this._parseLocaleAwareSettings(node, (locale, value) => this._addDisplayName(locale, value));
          node = this._xmlProcessor.selectSingleNode("o:Description", officeAppNode);
          this._parseLocaleAwareSettings(node, (locale, value) => this._addDescription(locale, value));
          node = this._xmlProcessor.selectSingleNode("o:AppDomains", officeAppNode);
          this._appDomains = this._parseAppDomains(node);
          node = this._xmlProcessor.selectSingleNode("o:IconUrl", officeAppNode);
          if (node) {
            this._parseLocaleAwareSettings(node, (locale, value) => this._addIconUrl(locale, value));
          }
          if (this.isForOfficeAppManifest()) {
            node = this._xmlProcessor.selectSingleNode("o:SupportUrl", officeAppNode);
            if (node) {
              this._parseLocaleAwareSettings(node, (locale, value) => this._addSupportUrl(locale, value));
            }
          }
          node = this._xmlProcessor.selectSingleNode("o:Signature", officeAppNode);
          if (node) {
            this._signature = this._xmlProcessor.getNodeValue(node);
          }
          this._parseExtensionSettings();
          node = this._xmlProcessor.selectSingleNode("o:Permissions", officeAppNode);
          this._permissions = this._parsePermission(node);
          // Taking snapshot is allowed by default
          this._allowSnapshot = true;
          node = this._xmlProcessor.selectSingleNode("o:AllowSnapshot", officeAppNode);
          if (node) {
            this._allowSnapshot = this._parseBooleanNode(node);
          }
          if (
            this._manifestSchemaVersion === OSF.ManifestSchemaVersion["1.1"] &&
            this._target !== OSF.OfficeAppType.MailApp
          ) {
            var nodeNamespace = "ov:";
            if (this._target == OSF.OfficeAppType.ContentApp) {
              nodeNamespace = "c:";
            }
            node = this._xmlProcessor.selectSingleNode(nodeNamespace + "VersionOverrides", officeAppNode);
            if (node) {
              this._parseWebApplicationInfo(this, node, nodeNamespace);
            }
          }
          // Com2Web equivalent addin info
          if (
            this._manifestSchemaVersion === OSF.ManifestSchemaVersion["1.1"] &&
            this._target == OSF.OfficeAppType.TaskPaneApp
          ) {
            var nodeNamespace = "ov:";
            node = this._xmlProcessor.selectSingleNode(nodeNamespace + "VersionOverrides", officeAppNode);
            if (node) {
              var equivalentAddinsNode = this._xmlProcessor.selectSingleNode(nodeNamespace + "EquivalentAddins", node);
              this._equivalentAddins = this._parseEquivalentAddins(equivalentAddinsNode, nodeNamespace);
            }
          }
          // Parsing the sourceLocation overrides for 1st party add-ins.
          if (this._manifestSchemaVersion === OSF.ManifestSchemaVersion["1.1"]) {
            var versionOverridesNode = this._xmlProcessor.selectSingleNode("ov:VersionOverrides", officeAppNode);
            if (versionOverridesNode) {
              this._manifestSourceLocationOverrides = this._parseSourceLocationOverrides(versionOverridesNode);
            }
          }
          if (
            this._manifestSchemaVersion === OSF.ManifestSchemaVersion["1.1"] &&
            this._target == OSF.OfficeAppType.TaskPaneApp
          ) {
            var extendedOverridesNode = this._xmlProcessor.selectSingleNode("o:ExtendedOverrides", officeAppNode);
            if (extendedOverridesNode != null) {
              this._parseExtendedOverrides(extendedOverridesNode);
            }
            var versionOverridesNode = this._xmlProcessor.selectSingleNode("ov:VersionOverrides", officeAppNode);
            if (versionOverridesNode !== null) {
              var hostsNode = this._xmlProcessor.selectSingleNode("ov:Hosts", versionOverridesNode);
              if (hostsNode !== null) {
                var hostNodes = this._xmlProcessor.selectNodes("ov:Host", hostsNode);
                if (hostNodes !== null) {
                  var len = hostNodes.length;
                  for (var i = 0; i < len; i++) {
                    var hostType = this.getNodeXsiType(hostNodes[i]);
                    // For now, we only support shared runtime feature on word, excel and PPT hosts.
                    if (hostType !== "Document" && hostType !== "Workbook" && hostType !== "Presentation") {
                      continue;
                    }
                    this._versionOverrides[hostType] = {};
                    var runtimesNode = this._xmlProcessor.selectSingleNode("ov:Runtimes", hostNodes[i]);
                    if (runtimesNode) {
                      // Parse runtimes.
                      this._versionOverrides[hostType]._runtimes = this._parseRuntimes(runtimesNode);
                    }

                    // Parse add-in commands and cache it.
                    var addinCommandsParser = new OfficeExt.Parser.AddinCommandsManifestParser(
                      hostType,
                      "DesktopFormFactor",
                    );
                    var customFunctionParser = new OfficeExt.Parser.AddinCommandsManifestParser(
                      hostType,
                      "AllFormFactors",
                    );
                    var errorManager = {
                      setErrorMessageForAddin: (errorMessage) => {
                        OsfMsAjaxFactory.msAjaxDebug.trace("Error parsing app manifest: " + errorMessage);
                      },
                    };

                    let entitlement: OfficeExt.AddinEntitlement = this._getEntitlement(this._solutionRef);
                    var addinCommands = addinCommandsParser.parseExtensions(
                      entitlement,
                      this as any,
                      errorManager,
                    ) as OfficeExt.Parser.VersionOverrides;
                    var customFunction = customFunctionParser.parseExtensions(
                      entitlement,
                      this as any,
                      errorManager,
                    ) as OfficeExt.Parser.VersionOverrides;
                    this._versionOverrides[hostType]._addinCommandsExtensionPoints = addinCommands.ExtensionPoints;
                    this._versionOverrides[hostType]._functionFileResid = addinCommands.functionFileResid;
                    this._versionOverrides[hostType]._customFunctionExtensionPoint = customFunction.ExtensionPoints[0];
                    this._versionOverrides[hostType]._showTaskpaneControls =
                      this._retrieveAppCommandShowTaskpaneControls(hostType);
                    if (this.isForOfficeAppManifest()) {
                      this._versionOverrides[hostType]._getStartedNode = addinCommands.getStartedNode;
                      this._versionOverrides[hostType]._resources = addinCommands.resources;
                    }
                    if (!this._resources) {
                      this._resources = addinCommands.resources;
                    }
                    // validate if taskpaneid and runtime resid pair of show taskpane control is valid or not.
                    this._validateShowTaskpaneSharedRuntime(hostType);
                    this._generateRibbonExtensionControlMap(hostType);
                  }
                }
              }
            }
          }
          versionSpecificDelegate.apply(this);
        }

        function OSF_Manifest_Manifest_Manifest1_0() {
          var node = this._xmlProcessor.selectSingleNode("o:Capabilities", officeAppNode);
          var nodes = this._xmlProcessor.selectNodes("o:Capability", node);
          this._capabilities = this._parseCapabilities(nodes);
        }
        function OSF_Manifest_Manifest_Manifest1_1() {
          var node = this._xmlProcessor.selectSingleNode("o:Hosts", officeAppNode);
          this._hosts = this._parseHosts(node);
          if (node) {
            // The xml property is supported by IE while outerHTML works with Chrome
            this._hostsXml = node.xml || node.outerHTML;
          }
          node = this._xmlProcessor.selectSingleNode("o:Requirements", officeAppNode);
          this._requirements = this._parseRequirements(node);
          if (node) {
            // The xml property is supported by IE while outerHTML works with Chrome
            this._requirementsXml = node.xml || node.outerHTML;
          }
          node = this._xmlProcessor.selectSingleNode("o:HighResolutionIconUrl", officeAppNode);
          if (node) {
            this._parseLocaleAwareSettings(node, (locale, url) => this._addHighResolutionIconUrl(locale, url));
          }
        }
      }

      getNodeXsiType(node): string {
        let nsMapping = this._xmlProcessor.getNamespaceMapping();
        let ns = nsMapping == null ? null : nsMapping["xsi"];
        if (ns != null) {
          return node.getAttributeNS(ns, "type");
        }
        return node.getAttribute("xsi:type");
      }
      getSourceLocationOverrideByResourceId(resourceId) {
        if (resourceId && this._manifestSourceLocationOverrides) {
          return this._manifestSourceLocationOverrides[resourceId];
        }
        return null;
      }
      getManifestSchemaVersion() {
        return this._manifestSchemaVersion;
      }
      getMarketplaceID() {
        return this._id;
      }
      getMarketplaceVersion() {
        return this._version;
      }
      getDefaultLocale() {
        return this._defaultLocale;
      }
      getLocale() {
        return this._UILocale;
      }
      getProviderName() {
        return this._providerName;
      }
      getIdIssuer() {
        return this._idIssuer;
      }
      getAlternateId() {
        return this._alternateId;
      }
      getSignature() {
        return this._signature;
      }
      getCapabilities() {
        return this._capabilities;
      }
      getDisplayName(locale) {
        return this._displayNames[locale.toLocaleLowerCase()];
      }
      getAddinDisplayName() {
        return this._getDefaultValue(this._addinDisplayNames);
      }
      getDefaultDisplayName() {
        return this._getDefaultValue(this._displayNames);
      }
      getDescription(locale) {
        locale = this._fixLocaleCasing(locale);
        return this._descriptions[locale];
      }
      getDefaultDescription() {
        return this._getDefaultValue(this._descriptions);
      }
      getIconUrl(locale) {
        locale = this._fixLocaleCasing(locale);
        return this._iconUrls[locale];
      }
      getDefaultIconUrl() {
        return this._getDefaultValue(this._iconUrls);
      }
      getSupportUrl(locale) {
        locale = this._fixLocaleCasing(locale);
        return this._supportUrls[locale];
      }
      getDefaultSupportUrl() {
        return this._getDefaultValue(this._supportUrls);
      }
      getSourceLocation(locale, formFactor) {
        var extensionSetting = this._getExtensionSetting(formFactor);
        var sourceLocations = extensionSetting.getSourceLocations();
        return sourceLocations[locale.toLocaleLowerCase()];
      }
      getDefaultSourceLocation(formFactor) {
        var extensionSetting = this._getExtensionSetting(formFactor);
        var sourceLocations = extensionSetting.getSourceLocations();
        return this._getDefaultValue(sourceLocations);
      }
      getDefaultWidth(formFactor?) {
        var extensionSetting = this._getExtensionSetting(formFactor);
        return extensionSetting.getDefaultWidth();
      }
      getDefaultHeight(formFactor?) {
        var extensionSetting = this._getExtensionSetting(formFactor);
        return extensionSetting.getDefaultHeight();
      }
      getTarget() {
        return this._target;
      }
      getOmexTargetCode() {
        switch (this._target) {
          case OSF.OfficeAppType.ContentApp:
            return 2;
          case OSF.OfficeAppType.TaskPaneApp:
            return 1;
          case OSF.OfficeAppType.MailApp:
            return 3;
          default:
            return 0;
        }
      }
      getPermission() {
        return this._permissions;
      }
      hasPermission(permissionNeeded) {
        return (this._permissions & permissionNeeded) === permissionNeeded;
      }
      getHosts() {
        return this._hosts;
      }
      getHostsXml() {
        return this._hostsXml;
      }
      getPayloadType() {
        return this._payloadType;
      }

      /// <summary>
      /// get the app's requirements
      /// </summary>
      /// <accessibility>public</accessibility>
      /// <returns>
      /// an object with two properties:
      /// sets: array of objects with 2 properties each {name, version}
      /// methods: array of strings, each representing a method
      /// if manifest does not support requirements, undefined is returned.
      /// </returns>
      getRequirements() {
        return this._requirements;
      }

      /// <summary>
      /// get the requirements that the app requires
      /// </summary>
      /// <accessibility>public</accessibility>
      /// <returns>
      /// an object with two properties:
      /// sets: array of objects with 2 properties each {name, version}
      /// methods: array of strings, each representing a method
      /// if manifest does not support requirements, undefined is returned.
      /// </returns>
      getRequirementsXml() {
        return this._requirementsXml;
      }
      getHighResolutionIconUrl(locale) {
        locale = this._fixLocaleCasing(locale);
        return this._highResolutionIconUrls[locale];
      }
      getDefaultHighResolutionIconUrl() {
        return this._getDefaultValue(this._highResolutionIconUrls);
      }
      getAppDomains() {
        return this._appDomains;
      }
      getInMemoryEToken() {
        return this._inMemoryEToken;
      }
      isAllowSnapshot() {
        return this._allowSnapshot;
      }

      /// <summary>
      /// add manifest domain to app domain list, sourcelocation, appdomain, functionfile.
      /// </summary>
      /// <accessibility>public</accessibility>
      /// <returns>a string representing the domain of the url.</returns>
      addManifestUrl(manifestUrl) {
        var urlDomain = OfficeExt.WACUtils.getDomainForUrl(manifestUrl);
        if (this._appDomains.indexOf(urlDomain) === -1) {
          this._appDomains.push(urlDomain);
        }
      }
      getWebApplicationResource() {
        return this._webApplicationResource;
      }
      getWebApplicationId() {
        return this._webApplicationId;
      }
      getWebApplicationMsaId() {
        return this._webApplicationMsaId;
      }
      getWebApplicationScopes() {
        return this._webApplicationScopes;
      }
      getWebApplicationAuthorizations() {
        return this._webApplicationAuthorizations;
      }
      getEquivalentAddins() {
        if (this._equivalentAddins) {
          return this._equivalentAddins.getEquivalentAddins();
        }
        return [];
      }
      isXLLCompatible() {
        if (this._equivalentAddins) {
          return this._equivalentAddins.isXLLCompatible();
        }
        return false;
      }
      isSSOAddin() {
        return !!this._webApplicationResource && !!this._webApplicationId;
      }
      containsAddinCommands(manifestHostType) {
        var hostNode = this._getCurrentHostTypeNode(manifestHostType);
        if (hostNode !== null) {
          var formFactorNode = this._xmlProcessor.selectSingleNode("ov:DesktopFormFactor", hostNode);
          if (formFactorNode != null) {
            return true;
          }
        }
        return false;
      }
      getRibbonExtensionControlMap() {
        return this._ribbonExtensionControls;
      }
      getExtendedOverrides() {
        return this._extendedOverrides;
      }
      getExtendedOverridesTokens() {
        if (this._extendedOverridesTokens) {
          return this._extendedOverridesTokens;
        }
        return [];
      }
      containsCustomFunctions(manifestHostType) {
        var hostNode = this._getCurrentHostTypeNode(manifestHostType);
        if (hostNode !== null) {
          var formFactorNode = this._xmlProcessor.selectSingleNode("ov:AllFormFactors", hostNode);
          if (formFactorNode !== null) {
            var extensionPointNodes = this._xmlProcessor.selectNodes("ov:ExtensionPoint", formFactorNode);
            if (extensionPointNodes !== null) {
              var len = extensionPointNodes.length;
              for (var i = 0; i < len; i++) {
                var extensionPointType = this.getNodeXsiType(extensionPointNodes[i]);
                if (extensionPointType === "CustomFunctions") {
                  return true;
                }
              }
            }
          }
        }
        return false;
      }
      containsCustomFunctionsForAppHost(appHostType) {
        var manifestHostType = OSF.getManifestHostType(appHostType);
        // Note: for Outlook, the manifest comes from host, Outlook does not support customFunctions, so skipping this entirely.
        return appHostType != OSF.HostType.Outlook && this.containsCustomFunctions(manifestHostType);
      }
      getSharedRuntimeForCustomFunctions(manifestHostType) {
        if (manifestHostType == null || this._versionOverrides == null) {
          return null;
        }
        var host = this._versionOverrides[manifestHostType];
        if (host == null || host._customFunctionExtensionPoint == null || host._runtimes == null) {
          return null;
        } else {
          return host._runtimes.getSharedRuntime(host._customFunctionExtensionPoint.pageResId);
        }
      }
      getSharedRuntimeForTaskpane(manifestHostType, controlId) {
        if (manifestHostType == null || controlId == null || this._versionOverrides == null) {
          return null;
        }
        var host = this._versionOverrides[manifestHostType];
        if (host == null || host._showTaskpaneControls == null || host._runtimes == null) {
          return null;
        }
        var showTaskpaneResid = null;
        this._iterateAppCommandShowTaskpaneControls(host._showTaskpaneControls, (control) => {
          if (control == null || control.action == null) {
            return false;
          }
          if (control.action.taskpaneId === controlId || control.id === controlId) {
            showTaskpaneResid = control.action.sourceLocationResid;
            return true; // Return true will break the iterator.
          }
          return false; // Reture false will continue the iterator.
        });
        return showTaskpaneResid == null ? null : host._runtimes.getSharedRuntime(showTaskpaneResid);
      }
      getTaskpaneIdByRuntimeId(manifestHostType, runtimeId) {
        if (manifestHostType == null || runtimeId == null || this._versionOverrides == null) {
          return null;
        }
        var host = this._versionOverrides[manifestHostType];
        if (host == null || host._showTaskpaneControls == null || host._runtimes == null) {
          return null;
        }
        var taskpaneId = null;
        this._iterateAppCommandShowTaskpaneControls(host._showTaskpaneControls, (control) => {
          if (control == null || control.action == null) {
            return false;
          }
          if (control.action.sourceLocationResid === runtimeId) {
            taskpaneId = control.action.taskpaneId;
            return true; // Return true will break the iterator.
          }
          return false; // Reture false will continue the iterator.
        });
        return taskpaneId;
      }
      getSharedRuntimeById(manifestHostType, runtimeId) {
        if (this._versionOverrides == null) {
          return null;
        }
        var host = this._versionOverrides[manifestHostType];
        if (host == null || host._runtimes == null) {
          return null;
        }
        return host._runtimes.getSharedRuntime(runtimeId);
      }

      /// <summary>
      /// get shared app runtime resid for uiless commands.
      /// Currently, this method only support excel host type, other aplications like word/ppt should shared same interface, but not been validated yet.
      /// </summary>
      /// <accessibility>public</accessibility>
      /// <returns>runtime object containing the shared app url resid; if not in shared app mode, null will be returned.</returns>
      getSharedRuntimeForAppCmdsExecuteFunction(manifestHostType) {
        if (manifestHostType == null || this._versionOverrides == null) {
          return null;
        }
        var host = this._versionOverrides[manifestHostType];
        if (host == null || host._runtimes == null) {
          return null;
        } else {
          return host._runtimes.getSharedRuntime(host._functionFileResid);
        }
      }

      /// <summary>
      /// Get shared runtime id for taskpane or UI-less (Word/PPT don't have custome function).
      /// </summary>
      /// <accessibility>public</accessibility>
      /// <param name="manifestHostType">manifest host type (type: string)</param>
      /// <param name="isForUiLess">get runtime for ui-less if it is true, or get runtime for taskpane if it is false (type: bool)</param>
      /// <param name="controlId">original control id, used for taskpane runtime only (type: string)</param>
      /// <returns>shared runtime resid for taskpane or uiless, or null if not a shared runtime.</returns>
      getSharedRuntimeId(manifestHostType, isForUiLess, controlId) {
        let runtime = isForUiLess
          ? this.getSharedRuntimeForAppCmdsExecuteFunction(manifestHostType)
          : this.getSharedRuntimeForTaskpane(manifestHostType, controlId);
        return runtime !== null ? runtime.Resid : null;
      }

      /// <summary>
      /// Get localized resource value from Resources in VersionOverrides.
      /// </summary>
      /// <accessibility>public</accessibility>
      /// <param name="resourceType">supported resource type (type: ResourceType)</param>
      /// <param name="resourceId">resource id (type: string)</param>
      /// <returns>resource value.</returns>
      getResourceValue(resourceType: ResourceType, resourceId: string) {
        if (resourceId == null || this._resources == null) {
          return null;
        }

        const resources = this._resources as OfficeExt.Parser.ManifestResourceManager;
        const resourcesMapping = {
          [ResourceType.Image]: resources.Images,
          [ResourceType.Url]: resources.Urls,
          [ResourceType.ShortString]: resources.ShortStrings,
          [ResourceType.LongString]: resources.LongStrings,
        };

        const resourcesOfChosenType = resourcesMapping[resourceType];
        if (resourcesOfChosenType == null) {
          return null;
        }

        return resourcesOfChosenType[resourceId];
      }

      /// <summary>
      /// Check whether the shared runtime has a short life time.
      /// </summary>
      /// <accessibility>public</accessibility>
      /// <param name="manifestHostType">manifest host type (type: string)</param>
      /// <param name="resid">shared runtime id (type: string)</param>
      /// <returns>true if the shared runtime has short life time. false otherwise</returns>
      sharedRuntimeHasShortLifeTime(manifestHostType, resid) {
        if (manifestHostType === null || resid === null || this._versionOverrides === null) {
          return false;
        }
        var host = this._versionOverrides[manifestHostType];
        if (host === null || host._runtimes === null) {
          return false;
        }
        let runtime = host._runtimes.getSharedRuntime(resid);
        return runtime === null ? false : runtime.LifeTime === RuntimeLifeTime.Short;
      }
      complementVersion(version: string) {
        // This method complements versions by adding ".0" where numbers are missing.
        // This method does not introduce any failures. Instead, it lets existing code deal with invalid versions.
        if (RegExp("^[0-9]{1,5}(\\.[0-9]{1,5}){3}$").test(version)) {
          // n.n.n.n
          // Nothing to do.
        } else if (RegExp("^[0-9]{1,5}(\\.[0-9]{1,5}){2}$").test(version)) {
          // n.n.n
          version = version + ".0";
        } else if (RegExp("^[0-9]{1,5}\\.[0-9]{1,5}$").test(version)) {
          // n.n
          version = version + ".0.0";
        } else if (RegExp("^[0-9]{1,5}$").test(version)) {
          // n
          version = version + ".0.0.0";
        } else {
          // The version is invalid.
          // However, we do nothing here.
          // If we introduce a new failure at this junction point, it may possibly break some scenarios that are currently working.
          // That's why we defer to the processing code downstream to deal with this invalid version as before.
        }
        return version;
      }

      isForOfficeAppManifest(): boolean {
        return false;
      }
      converterLogging(): boolean {
        return false;
      }

      getSolutionReference(): OfficeExt.OsfSolutionReference {
        return this._solutionRef;
      }

      addLocaleSeen(locale: string): void {
        if (locale != null) {
          this._localesSeen[locale.toLowerCase()] = true;
        }
      }

      _iterateAppCommandShowTaskpaneControls(showTaskpaneControls, callback) {
        if (showTaskpaneControls == null || callback == null) {
          return;
        }
        for (var i = 0; i < showTaskpaneControls.length; i++) {
          if (callback(showTaskpaneControls[i])) {
            break;
          }
        }
      }
      _generateRibbonExtensionControlMap(manifestHostType) {
        if (manifestHostType == null || this._versionOverrides == null) {
          return null;
        }
        var host = this._versionOverrides[manifestHostType];
        var ribbonExtensionControls = [];
        // Check if custom ribbon commands are defined in the manifest.
        if (host != null && host._addinCommandsExtensionPoints != null) {
          var len = host._addinCommandsExtensionPoints.length;
          for (var i = 0; i < len; i++) {
            var extPoint = host._addinCommandsExtensionPoints[i];
            // Only support ribbon commands, not conext menu currently.
            if (extPoint.type === "PrimaryCommandSurface") {
              if (extPoint.tabs) {
                // Walk through tabs.
                for (var tabIdx = 0; tabIdx < extPoint.tabs.length; tabIdx++) {
                  var tab = extPoint.tabs[tabIdx];
                  this._ribbonExtensionControls[tab.id] = tab;
                  this._addRibbonControlsToMap(tab);
                }
              }
            }
          }
        }
      }

      /// <summary>
      /// Recursively iterate through ribbon controls/children and add them to the cache dictionary.
      /// MenuControl is excluded because it is notsupported by Dynamic Ribbon /Enable/Disable API.
      /// </summary>
      _addRibbonControlsToMap(parentControl) {
        if (parentControl && parentControl.children) {
          for (var idx = 0; idx < parentControl.children.length; idx++) {
            var control = parentControl.children[idx];
            if (control && !(control instanceof OfficeExt.Parser.MenuControl)) {
              this._ribbonExtensionControls[control.id] = control;
            }
            this._addRibbonControlsToMap(control);
          }
        }
      }

      /// <summary>
      /// Go though this._versionOverrides[manifestHostType]._addinCommandsExtensionPoints,
      /// get a list of appCommands show taskpane controls.
      /// </summary>
      _retrieveAppCommandShowTaskpaneControls(manifestHostType) {
        if (manifestHostType == null || this._versionOverrides == null) {
          return null;
        }
        var host = this._versionOverrides[manifestHostType];
        var appCommandShowTaskpaneControls = [];
        if (host != null && host._addinCommandsExtensionPoints != null) {
          var len = host._addinCommandsExtensionPoints.length;
          for (var i = 0; i < len; i++) {
            var extPoint = host._addinCommandsExtensionPoints[i];
            if (extPoint == null) {
              continue;
            }
            if (extPoint.type === "PrimaryCommandSurface") {
              if (extPoint.tabs == null) {
                continue;
              }
              for (var j = 0; j < extPoint.tabs.length; j++) {
                var tab = extPoint.tabs[j]; // We could only have one tab, either officeTab or customTab.
                if (tab == null || tab.children == null) {
                  continue;
                }
                for (var groupIndex = 0; groupIndex < tab.children.length; groupIndex++) {
                  var group = tab.children[groupIndex];
                  if (group == null || group.children == null) {
                    continue;
                  }
                  this._getShowTaskpaneControlsFromControlsParent(group, appCommandShowTaskpaneControls);
                }
              }
            } else if (extPoint.type === "ContextMenu") {
              if (extPoint.children == null) {
                continue;
              }
              var officeMenuNode = extPoint.children[0]; // We could only have one officeMenuNode.
              if (officeMenuNode == null || officeMenuNode.children == null) {
                continue;
              }
              this._getShowTaskpaneControlsFromControlsParent(officeMenuNode, appCommandShowTaskpaneControls);
            }
          }
        }
        return appCommandShowTaskpaneControls;
      }
      /// <summary>
      /// Get appCommands showtaskpane controls infomation from controls parent.
      /// For PrimaryCommandSurface, the controls parent should be "group";
      /// For ContextMenu, the controls parent should be "OfficeMenuNode".
      /// </summary>
      _getShowTaskpaneControlsFromControlsParent(controlsParent, appCommandShowTaskpaneControls) {
        if (controlsParent == null || controlsParent.children == null || appCommandShowTaskpaneControls == null) {
          return;
        }
        for (var controlIndex = 0; controlIndex < controlsParent.children.length; controlIndex++) {
          var control = controlsParent.children[controlIndex];
          if (control != null) {
            if (control.controlType === "Button") {
              if (control.action != null && control.actionType === "ShowTaskpane") {
                appCommandShowTaskpaneControls.push(control);
              }
            } else {
              // Logic to handle when control type is Menu
              if (control.children == null) {
                continue;
              }
              for (var itemIndex = 0; itemIndex < control.children.length; itemIndex++) {
                var menuItem = control.children[itemIndex];
                if (menuItem != null && menuItem.action != null && menuItem.actionType === "ShowTaskpane") {
                  appCommandShowTaskpaneControls.push(menuItem);
                }
              }
            }
          }
        }
      }

      /// Currently, this method only support excel host type, other aplications like word/ppt should shared same interface, but not been validated yet.
      _validateShowTaskpaneSharedRuntime(manifestHostType) {
        if (manifestHostType == null || this._versionOverrides == null) {
          return;
        }
        var host = this._versionOverrides[manifestHostType];
        if (host == null || host._runtimes == null || host._showTaskpaneControls == null) {
          return;
        }
        var validsharedTaskPaneRuntimes = [];
        this._iterateAppCommandShowTaskpaneControls(host._showTaskpaneControls, (control) => {
          if (control == null || control.action == null) {
            return false;
          }
          var sharedRuntime = host._runtimes.getSharedRuntime(control.action.sourceLocationResid);
          var sharedRuntimeId = null;
          if (sharedRuntime == null || sharedRuntime.LifeTime != RuntimeLifeTime.Long) {
            if (control.action.taskpaneId == null) {
              // If not long shared runtime and no taskpaneId provided, we will return false will continue the iterator.
              return false;
            }
          } else {
            // This will be a shared runtime with long life time, we only need to add long runtime into sharedRuntimeSet.
            sharedRuntimeId = sharedRuntime.Resid;
          }
          var taskpaneIdAndResIdPair = new Array(control.action.taskpaneId, sharedRuntimeId);
          var needToAddActionToSharedRuntimeSet = true;
          // Go through all items in sharedRuntimeSet, to determine if action need to be put into the set.
          // Will throw excetion for invalid scenarios.
          for (var i = 0; i < validsharedTaskPaneRuntimes.length; i++) {
            if (
              validsharedTaskPaneRuntimes[i][0] == taskpaneIdAndResIdPair[0] &&
              validsharedTaskPaneRuntimes[i][1] == taskpaneIdAndResIdPair[1]
            ) {
              if (taskpaneIdAndResIdPair[0] == null) {
                throw OsfMsAjaxFactory.msAjaxError.argument(
                  "Manifest parser failure: resid and taskpaneid not correct",
                );
              } else {
                needToAddActionToSharedRuntimeSet = false;
                break;
              }
            } else if (
              (validsharedTaskPaneRuntimes[i][1] == taskpaneIdAndResIdPair[1] &&
                validsharedTaskPaneRuntimes[i][1] != null) ||
              (validsharedTaskPaneRuntimes[i][0] == taskpaneIdAndResIdPair[0] &&
                validsharedTaskPaneRuntimes[i][0] != null)
            ) {
              needToAddActionToSharedRuntimeSet = false;
              throw OsfMsAjaxFactory.msAjaxError.argument("Manifest parser failure: resid and taskpaneid not correct");
            }
          }
          if (needToAddActionToSharedRuntimeSet) {
            validsharedTaskPaneRuntimes.push(taskpaneIdAndResIdPair);
          }
          return false; // Reture false will continue the iterator.
        });
      }

      /// <summary>
      /// Help method to get the default value from the locale aware setting object.
      /// Use default locale if it exists, otherwise return the first value.
      /// </summary>
      /// <accessibility>private</accessibility>
      /// <param name="locale">locale aware setting object</param>
      /// <returns>a string representing the default value for the locale aware setting object.</returns>
      _getDefaultValue(obj) {
        var localeValue;
        if (this._UILocale) {
          localeValue = obj[this._UILocale] || obj[this._UILocale.toLocaleLowerCase()] || undefined;
        }
        if (!localeValue && this._defaultLocale) {
          localeValue = obj[this._defaultLocale] || obj[this._defaultLocale.toLocaleLowerCase()] || undefined;
        }
        if (!localeValue) {
          var locale;
          for (var p in obj) {
            //return the first value
            locale = p;
            break;
          }
          localeValue = obj[locale];
        }
        return localeValue;
      }

      /// <summary>
      /// Help method to parse locale aware settings.
      /// </summary>
      /// <accessibility>private</accessibility>
      /// <param name="localeAwareNode">DOM node</param>
      /// <param name="addCallback">callback to add the parsed locale aware settings</param>
      _getExtensionSetting(formFactor) {
        var extensionSetting;
        if (typeof this._extensionSettings[formFactor] != "undefined") {
          extensionSetting = this._extensionSettings[formFactor];
        } else {
          for (var p in this._extensionSettings) {
            extensionSetting = this._extensionSettings[p];
            break;
          }
        }
        return extensionSetting;
      }
      _addDisplayName(locale, value) {
        this._displayNames[locale.toLocaleLowerCase()] = value;
      }
      _addDescription(locale, value) {
        locale = this._fixLocaleCasing(locale);
        this._descriptions[locale] = value;
      }
      _addIconUrl(locale, value) {
        locale = this._fixLocaleCasing(locale);
        this._iconUrls[locale] = value;
      }
      _addSupportUrl(locale, value) {
        locale = this._fixLocaleCasing(locale);
        this._supportUrls[locale] = value;
      }
      _fixLocaleCasing(locale: string): string {
        // The locales should be insensitive but some are not.
        // Changing this now could break some manifests so just doing it here for the xml to json converter
        if (this.isForOfficeAppManifest() && locale != null) {
          return locale.toLowerCase();
        }
        return locale;
      }
      _parseLocaleAwareSettings(localeAwareNode, addCallback) {
        if (!localeAwareNode) {
          throw OsfMsAjaxFactory.msAjaxError.argument("Manifest");
        }
        var defaultValue = localeAwareNode.getAttribute("DefaultValue");
        addCallback(this._defaultLocale, defaultValue);
        var overrideNodes = this._xmlProcessor.selectNodes("o:Override", localeAwareNode);
        if (overrideNodes) {
          var len = overrideNodes.length;
          for (var i = 0; i < len; i++) {
            var node = overrideNodes[i];
            var locale = node.getAttribute("Locale");
            this.addLocaleSeen(locale);
            var value = node.getAttribute("Value");
            addCallback(locale, value);
          }
        }
      }
      _parseBooleanNode(node) {
        if (!node) {
          return false;
        } else {
          var value = this._xmlProcessor.getNodeValue(node).toLowerCase();
          return value === "true" || value === "1";
        }
      }
      _parseIdIssuer(node) {
        if (!node) {
          return OSF.ManifestIdIssuer.Custom;
        } else {
          var value = this._xmlProcessor.getNodeValue(node);
          return OSF.OUtil.parseEnum(value, OSF.ManifestIdIssuer);
        }
      }
      _parseCapabilities(nodes) {
        var capabilities = [];
        var capability;
        for (var i = 0; i < nodes.length; i++) {
          var node = nodes[i];
          capability = node.getAttribute("Name");
          capability = OSF.OUtil.parseEnum(capability, OSF.Capability);
          capabilities.push(capability);
        }
        return capabilities;
      }
      _parsePermission(capabilityNode) {
        if (!capabilityNode) {
          throw OsfMsAjaxFactory.msAjaxError.argument("Manifest");
        }
        var value = this._xmlProcessor.getNodeValue(capabilityNode);
        return OSF.OUtil.parseEnum(value, OSF.OsfControlPermission);
      }
      _parseExtensionSettings() {
        var settings;
        var settingNode;
        var node;
        for (var formFactor in OSF.FormFactor) {
          var officeAppNode = this._xmlProcessor.selectSingleNode("o:OfficeApp");
          settingNode = this._xmlProcessor.selectSingleNode("o:" + OSF.FormFactor[formFactor], officeAppNode);
          if (settingNode) {
            settings = new OSF.Manifest.ExtensionSettings();
            node = this._xmlProcessor.selectSingleNode("o:SourceLocation", settingNode);
            var addSourceLocation = (locale, value) => {
              settings._addSourceLocation(locale, value);
              this.addManifestUrl(value);
            };
            this._parseLocaleAwareSettings(node, addSourceLocation);
            node = this._xmlProcessor.selectSingleNode("o:RequestedWidth", settingNode);
            if (node) {
              settings._setDefaultWidth(this._xmlProcessor.getNodeValue(node));
            }
            node = this._xmlProcessor.selectSingleNode("o:RequestedHeight", settingNode);
            if (node) {
              settings._setDefaultHeight(this._xmlProcessor.getNodeValue(node));
            }
            this._extensionSettings[formFactor] = settings;
          }
        }
        if (!settings) {
          //no setting found
          throw OsfMsAjaxFactory.msAjaxError.argument("Manifest");
        }
      }
      _parseHosts(hostsNode) {
        var targetHosts = [];
        if (hostsNode) {
          var hostNodes = this._xmlProcessor.selectNodes("o:Host", hostsNode);
          for (var i = 0; i < hostNodes.length; i++) {
            targetHosts.push(hostNodes[i].getAttribute("Name"));
          }
        }
        return targetHosts;
      }

      _parseWebApplicationInfo(obj: any, parentNode: any, nodeNamespace: string): void {
        var webApplicationInfoNode = this._xmlProcessor.selectSingleNode(
          nodeNamespace + "WebApplicationInfo",
          parentNode,
        );
        if (webApplicationInfoNode) {
          var webApplicationResourceNode = this._xmlProcessor.selectSingleNode(
            nodeNamespace + "Resource",
            webApplicationInfoNode,
          );

          if (webApplicationResourceNode) {
            obj._webApplicationResource = this._xmlProcessor.getNodeValue(webApplicationResourceNode);
          }
          var webApplicationIdNode = this._xmlProcessor.selectSingleNode(nodeNamespace + "Id", webApplicationInfoNode);
          obj._webApplicationId = this._xmlProcessor.getNodeValue(webApplicationIdNode);
          // MsaId is needed to support in case of AAD (v1) and MSA (login.live.com).
          // TODO: When migrate to MSAL (v2) this should be deprecated.
          var webApplicationMsaIdNode = this._xmlProcessor.selectSingleNode(
            nodeNamespace + "MsaId",
            webApplicationInfoNode,
          );
          if (webApplicationMsaIdNode) {
            obj._webApplicationMsaId = this._xmlProcessor.getNodeValue(webApplicationMsaIdNode);
          } else {
            obj._webApplicationMsaId = this._webApplicationId;
          }
          var webApplicationScopesNode = this._xmlProcessor.selectSingleNode(
            nodeNamespace + "Scopes",
            webApplicationInfoNode,
          );
          obj._webApplicationScopes = this._parseWebApplicationScopes(webApplicationScopesNode, nodeNamespace);
          obj._webApplicationAuthorizations = this._parseWebAppInfoAuthorizations(
            webApplicationInfoNode,
            nodeNamespace,
          );
        }
      }

      _parseWebApplicationScopes(webApplicationScopesNode, nodeNamespace) {
        var scopes = [];
        if (webApplicationScopesNode) {
          var scopeNodes = this._xmlProcessor.selectNodes(nodeNamespace + "Scope", webApplicationScopesNode);
          for (var i = 0; i < scopeNodes.length; i++) {
            scopes.push(this._xmlProcessor.getNodeValue(scopeNodes[i]));
          }
        }
        return scopes;
      }
      _parseWebAppInfoAuthorizations(webAppInfoAuthsNode, nodeNamespace) {
        var authorizations = [];
        var authorizationsNode = this._xmlProcessor.selectSingleNode(
          nodeNamespace + "Authorizations",
          webAppInfoAuthsNode,
        );
        if (authorizationsNode) {
          var authorizationNodes = this._xmlProcessor.selectNodes(nodeNamespace + "Authorization", authorizationsNode);
          if (authorizationNodes) {
            for (var authNodeIndex = 0; authNodeIndex < authorizationNodes.length; authNodeIndex++) {
              var authNode = authorizationNodes[authNodeIndex];
              var authorization = new OSF.Manifest.WebAppInfoAuthorization();
              var resourceNode = this._xmlProcessor.selectSingleNode(nodeNamespace + "Resource", authNode);
              if (resourceNode) {
                authorization._resource = this._xmlProcessor.getNodeValue(resourceNode);
              }
              var scopesNode = this._xmlProcessor.selectSingleNode(nodeNamespace + "Scopes", authNode);
              if (scopesNode) {
                var scopeNodes = this._xmlProcessor.selectNodes(nodeNamespace + "Scope", scopesNode);
                if (scopeNodes) {
                  var scopes = [];
                  for (var scopeNodeIndex = 0; scopeNodeIndex < scopeNodes.length; scopeNodeIndex++) {
                    var scopeNode = scopeNodes[scopeNodeIndex];
                    scopes.push(this._xmlProcessor.getNodeValue(scopeNode));
                  }
                  authorization._scopes = scopes;
                }
              }
              authorizations.push(authorization);
            }
          }
        }
        return authorizations;
      }
      _parseRequirements(requirementsNode, nodeNamespace?: string) {
        var requirements = {
          sets: [],
          methods: [],
        };
        if (requirementsNode) {
          let ns: string = nodeNamespace == null ? "o:" : nodeNamespace;
          var setsNode = this._xmlProcessor.selectSingleNode(ns + "Sets", requirementsNode);
          requirements.sets = this._parseSets(setsNode, ns);
          var methodsNode = this._xmlProcessor.selectSingleNode(ns + "Methods", requirementsNode);
          requirements.methods = this._parseMethods(methodsNode, ns);
        }
        return requirements;
      }
      _parseSets(setsNode, nodeNamespace?: string) {
        var sets = [];
        if (setsNode) {
          let ns: string = nodeNamespace == null ? "o:" : nodeNamespace;
          var defaultVersion = setsNode.getAttribute("DefaultMinVersion");
          var setNodes = this._xmlProcessor.selectNodes(ns + "Set", setsNode);
          for (var i = 0; i < setNodes.length; i++) {
            var setNode = setNodes[i];
            var overrideVersion = setNode.getAttribute("MinVersion");
            sets.push({
              name: setNode.getAttribute("Name"),
              version: overrideVersion || defaultVersion,
            });
          }
        }
        return sets;
      }
      _parseMethods(methodsNode, nodeNamespace?: string) {
        var methods = [];
        if (methodsNode) {
          let ns: string = nodeNamespace == null ? "o:" : nodeNamespace;
          var methodNodes = this._xmlProcessor.selectNodes(ns + "Method", methodsNode);
          for (var i = 0; i < methodNodes.length; i++) {
            methods.push(methodNodes[i].getAttribute("Name"));
          }
        }
        return methods;
      }
      _parseSourceLocationOverrides(versionOverridesNode) {
        var idToSouceLocationOverrideMapping = {};
        if (versionOverridesNode) {
          var resourcesNode = this._xmlProcessor.selectSingleNode("ov:Resources", versionOverridesNode);
          if (resourcesNode) {
            var btUrlsNode = this._xmlProcessor.selectSingleNode("bt:Urls", resourcesNode);
            if (btUrlsNode) {
              var urlList = this._xmlProcessor.selectNodes("bt:Url", btUrlsNode);
              if (urlList) {
                for (var x = 0; x < urlList.length; x++) {
                  var node = urlList[x];
                  var id = node.getAttribute("id");
                  var sourceLocationOverride = node.getAttribute("DefaultValue");
                  if (id && sourceLocationOverride) {
                    idToSouceLocationOverrideMapping[id] = sourceLocationOverride;
                  }
                }
              }
            }
          }
        }
        return idToSouceLocationOverrideMapping;
      }
      _parseAppDomains(appDomainsNode) {
        var appDomains = [];
        if (appDomainsNode) {
          var appDomainNodes = this._xmlProcessor.selectNodes("o:AppDomain", appDomainsNode);
          for (var i = 0; i < appDomainNodes.length; i++) {
            var url = this._xmlProcessor.getNodeValue(appDomainNodes[i]);
            if (OSF.OUtil.doesUrlHaveSupportedProtocol(url)) {
              var appDomain = OfficeExt.WACUtils.getDomainForUrl(url);
              if (appDomains.indexOf(appDomain) === -1) {
                appDomains.push(appDomain);
              }
            }
          }
        }
        return appDomains;
      }
      _parseRuntimes(runtimesNode) {
        if (runtimesNode == null) {
          return null;
        }
        var runtimes = new OSF.Manifest.Runtimes();
        var runtimeNodes = this._xmlProcessor.selectNodes("ov:Runtime", runtimesNode);
        if (runtimeNodes == null) {
          return null;
        }
        for (var i = 0; i < runtimeNodes.length; i++) {
          var runtime = this._parseRuntime(runtimeNodes[i]);
          runtimes.add(runtime);
        }
        return runtimes;
      }
      _parseRuntime(runtimeNode) {
        if (runtimeNode == null) {
          return null;
        }
        var runtime = new OSF.Manifest.Runtime();
        runtime.Resid = runtimeNode.getAttribute("resid");
        if (runtimeNode.getAttribute("lifetime") === "long") {
          runtime.LifeTime = RuntimeLifeTime.Long;
        } else {
          runtime.LifeTime = RuntimeLifeTime.Short;
        }

        if (this.isForOfficeAppManifest()) {
          var runtimeOverrides = this._xmlProcessor.selectNodes("ov:Override", runtimeNode);
          if (runtimeOverrides != null && Array.isArray(runtimeOverrides)) {
            for (var i = 0; i < runtimeOverrides.length; i++) {
              let runtimeOverride: RuntimeOverride = new RuntimeOverride();
              runtimeOverride.Type = runtimeNode.getAttribute("type");
              runtimeOverride.Resid = runtimeNode.getAttribute("resid");
              runtime.Overrides.add(runtimeOverride);
            }
          }
        }

        return runtime;
      }
      _parseEquivalentAddins(equivalentAddinsNode, nodeNamespace) {
        var equivalentAddins = new OSF.Manifest.EquivalentAddins();
        if (equivalentAddinsNode) {
          var equivalentAddinNodes = this._xmlProcessor.selectNodes(
            nodeNamespace + "EquivalentAddin",
            equivalentAddinsNode,
          );
          for (var i = 0; i < equivalentAddinNodes.length; i++) {
            var equivalentAddin = this._parseEquivalentAddin(equivalentAddinNodes[i], nodeNamespace);
            equivalentAddins.add(equivalentAddin);
          }
        }
        return equivalentAddins;
      }
      _parseEquivalentAddin(equivalentAddinNode, nodeNamespace) {
        var equivalentAddin = new OSF.Manifest.EquivalentAddin();
        if (equivalentAddinNode) {
          var progIdNode = this._xmlProcessor.selectSingleNode(nodeNamespace + "ProgId", equivalentAddinNode);
          if (progIdNode) {
            equivalentAddin._progId = this._xmlProcessor.getNodeValue(progIdNode);
          }
          var displayNameNode = this._xmlProcessor.selectSingleNode(nodeNamespace + "DisplayName", equivalentAddinNode);
          if (displayNameNode) {
            equivalentAddin._displayName = this._xmlProcessor.getNodeValue(displayNameNode);
          }
          var fileNameNode = this._xmlProcessor.selectSingleNode(nodeNamespace + "FileName", equivalentAddinNode);
          if (fileNameNode) {
            equivalentAddin._fileName = this._xmlProcessor.getNodeValue(fileNameNode);
          }
          var typeNode = this._xmlProcessor.selectSingleNode(nodeNamespace + "Type", equivalentAddinNode);
          if (typeNode) {
            var type = "" + this._xmlProcessor.getNodeValue(typeNode);
            equivalentAddin._type = type.toUpperCase();
          } else {
            throw OsfMsAjaxFactory.msAjaxError.argument("Manifest");
          }
        }
        return equivalentAddin;
      }
      _parseExtendedOverrides(extendedOverridesNode) {
        this._extendedOverrides = {
          url: extendedOverridesNode.getAttribute("Url"),
          resourcesUrl: extendedOverridesNode.getAttribute("ResourcesUrl"),
          hasFinalUrls: false,
        };
        var extendedOverridesTokensNode = this._xmlProcessor.selectSingleNode("o:Tokens", extendedOverridesNode);
        if (extendedOverridesTokensNode != null) {
          var extendedOverridesTokenNodes = this._xmlProcessor.selectNodes("o:Token", extendedOverridesTokensNode);
          if (extendedOverridesTokenNodes != null) {
            var extendedOverridesTokens: Array<OfficeExt.ExtendedOverridesToken> = [];
            for (var i = 0; i < extendedOverridesTokenNodes.length; i++) {
              var curExtendedOverridesTokenNode = extendedOverridesTokenNodes[i];
              var overridesNode = this._xmlProcessor.selectNodes("o:Override", curExtendedOverridesTokenNode);
              var overrides = [];
              var curExtendedOverridesNodeType = this.getNodeXsiType(curExtendedOverridesTokenNode);
              if (curExtendedOverridesNodeType == OSF.ExtendedManifestSupportTokens.Requirements) {
                for (var j = 0; j < overridesNode.length; j++) {
                  var requirements = this._xmlProcessor.selectSingleNode("o:Requirements", overridesNode[j]);
                  var override: OfficeExt.ExtendedOverridesTokenOverride = {
                    value: overridesNode[j].getAttribute("Value"),
                    data: this._parseRequirements(requirements),
                  };
                  overrides.push(override);
                }
              } else if (curExtendedOverridesNodeType == OSF.ExtendedManifestSupportTokens.Locale) {
                for (var j = 0; j < overridesNode.length; j++) {
                  var override: OfficeExt.ExtendedOverridesTokenOverride = {
                    value: overridesNode[j].getAttribute("Value"),
                    data: overridesNode[j].getAttribute("Locale").toLowerCase(), // make locale value to lowerCase, this helps computeLocaleToken to avoid toLowerCase in for loop
                  };
                  overrides.push(override);
                }
              }
              var extendedOverridesToken: OfficeExt.ExtendedOverridesToken = {
                name: curExtendedOverridesTokenNode.getAttribute("Name"),
                defaultValue: curExtendedOverridesTokenNode.getAttribute("DefaultValue"),
                type: this.getNodeXsiType(curExtendedOverridesTokenNode),
                overrides: overrides,
              };
              extendedOverridesTokens.push(extendedOverridesToken);
            }
            this._extendedOverridesTokens = extendedOverridesTokens;
          }
        }
      }
      _addHighResolutionIconUrl(locale, url) {
        locale = this._fixLocaleCasing(locale);
        this._highResolutionIconUrls[locale] = url;
      }
      _isAddinCommandsManifest(manifestHostType) {
        return this.containsAddinCommands(manifestHostType) || this.containsCustomFunctions(manifestHostType);
      }
      _getCurrentHostTypeNode(manifestHostType) {
        if (this._xmlProcessor) {
          var officeAppNode = this._xmlProcessor.selectSingleNode("o:OfficeApp");
          if (officeAppNode !== null && this.getManifestSchemaVersion() === OSF.ManifestSchemaVersion["1.1"]) {
            var overridesNode = this._xmlProcessor.selectSingleNode("ov:VersionOverrides", officeAppNode);
            if (overridesNode !== null) {
              var hostsNode = this._xmlProcessor.selectSingleNode("ov:Hosts", overridesNode);
              if (hostsNode !== null) {
                var hostNodes = this._xmlProcessor.selectNodes("ov:Host", hostsNode);
                if (hostNodes !== null) {
                  var len = hostNodes.length;
                  for (var i = 0; i < len; i++) {
                    var hostType = this.getNodeXsiType(hostNodes[i]);
                    if (hostType === manifestHostType) {
                      return hostNodes[i];
                    }
                  }
                }
              }
            }
          }
        }
        return null;
      }

      _getEntitlement(solRef: OfficeExt.OsfSolutionReference): OfficeExt.AddinEntitlement {
        if (solRef == null) {
          var solRef: OfficeExt.OsfSolutionReference = {
            solutionId: this._id,
            version: this._version,
            storeType: OSF.StoreType.FileSystem, // if not set we will use Filesystem as default StoreType
            storeId: this._UILocale,
            assetId: this._id,
            assetStoreId: null,
          };
          this._solutionRef = solRef;
        }

        let entitlement: OfficeExt.AddinEntitlement = {
          solutionId: this._solutionRef.solutionId,
          version: this._solutionRef.version,
          storeType: this._solutionRef.storeType,
          storeId: this._solutionRef.storeId,
          assetId: this._solutionRef.assetId,
          assetStoreId: this._solutionRef.assetStoreId,
          targetType: this._target,
        };

        return entitlement;
      }
    }
  }
}
